import {Component, Inject, OnInit} from '@angular/core';
import {SuppliersService} from '../../../services/suppliers.service';
import {Observable} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {ConfirmDialogComponent} from '../../dialogs/confirm-dialog.component';
import {APP_GUIDS, AppGuids} from '../../../app.guids';
import {MatDialog} from '@angular/material/dialog';
import {CoreService, ProleisObject} from "@proleis/proleis-rest-client";
import {NotificationService} from "@proleis/proleis-web-app";

@Component({
  selector: 'ps-pm-documents',
  templateUrl: 'pm-snr-documents.component.html'
})
export class PmSnrDocumentsComponent implements OnInit {

  snr: Observable<ProleisObject>;
  documents: Observable<ProleisObject[]>;

  constructor(private suppliersService: SuppliersService, public route: ActivatedRoute, @Inject(APP_GUIDS) private guids: AppGuids,
              private cs: CoreService, private ns: NotificationService, private dialog: MatDialog) {
  }

  ngOnInit() {
    const aliasFields = 'CREATOR_NAME=ERSTELLER_ID.TEXT;CHANGE_NAME=BENUTZER_ID.TEXT';
    const params = this.route.snapshot.params;
    this.documents = this.suppliersService.getPartDocuments(params.constructionId, params.indexId, params.snrId, aliasFields);
    this.snr = this.suppliersService.getPmSnr(params.constructionId, params.indexId, params.snrId);
  }

  deleteDocument(doc: ProleisObject) {
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: doc.NAME + ' wirklich löschen?'
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.cs.executeAction(doc.OBJECT_ID, '§' + this.guids.GUID_ACTION_DELETE_PM_OBJECT).subscribe(result => {
          this.ns.showNotification('SNR ' + doc.NAME + ' wurde gelöscht.');
        });
      }
    });
  }
}
